"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACKGROUND_COLORS = exports.CONTENT_COLORS = void 0;

var _color = _interopRequireDefault(require("../../constants/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var backgroundColors = _color.default.background,
    contentColors = _objectWithoutProperties(_color.default, ["background"]);

function getColorValues(ColorObj) {
  return Object.keys(ColorObj).reduce(function (colors, key) {
    if (key === 'white' || key === 'black') {
      return [].concat(_toConsumableArray(colors), [ColorObj[key]]);
    } else {
      return [].concat(_toConsumableArray(colors), _toConsumableArray(Object.values(ColorObj[key])));
    }
  }, []);
}

var CONTENT_COLORS = getColorValues(contentColors);
exports.CONTENT_COLORS = CONTENT_COLORS;
var BACKGROUND_COLORS = getColorValues(backgroundColors);
exports.BACKGROUND_COLORS = BACKGROUND_COLORS;